import styled from 'styled-components';
import { media } from '../css';

export const LocationMapContainer = styled.div`
  position: relative;
  margin-bottom: 24px;

  /* Make map fill container */
  > div {
    position: absolute;
    top: 0;
    left: 0;
  }

  /* Maintain a 16:9 aspect ratio */
  &:after {
    content: '';
    display: block;
    padding-top: ${(166 / 276) * 100}%;

    ${media.greaterThan('lg')`
      padding-top: ${(401 / 995) * 100}%;
    `};
  }
`;
